// shared-components/features/auth/UnauthorizedPage.jsx
export const UnauthorizedPage = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full text-center">
        <h1 className="text-3xl font-extrabold text-gray-900 mb-4">
          Access Denied
        </h1>
        <p className="text-lg text-gray-600 mb-8">
          You don&apos;t have permission to access the admin area for this
          website.
        </p>
        <a
          href="/"
          className="inline-block px-4 py-2 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
        >
          Return to Homepage
        </a>
      </div>
    </div>
  );
};
